import React from "react";
import styled from "styled-components";

export default styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    cursor: move;
`;